export default "__VITE_ASSET__ab93f86c__"